<template>
    <Sections>
        <SectionJumbo
            :image="$config.public.uploads + 'images-general/photoroom-20221110122625-edit1-2.jpg'"
            imageAlt="Andy's signature guitar and ukulele"
            imageOpacity="opacity-20"
            heading="Signature Products"
            headingColor="text-white"
            content="<p>Check out my range of signature products</p>"
            contentColor="text-white"
            buttonText="Lets Go"
            buttonHref="https://shop.andyguitar.co.uk/collections/signature-collection"
            buttonTarget="_blank"
            :textCentered="false"
        ></SectionJumbo>
        <SectionYoutubeWithText
            heading="Signature Products"
            headingComponent="h2"
            :flip="true"
            content="<ul><li>Check out my new signature products</li><li>Carefully selected for your enjoyment</li><li>Guitar, Ukulele, Capo</li></ul>"
            buttonText="Shop"
            buttonHref="https://shop.andyguitar.co.uk/"
            buttonTarget="_blank"
            idYoutube="vTsL47Zrqd4"
        >
        </SectionYoutubeWithText>
        <SectionCards v-bind="overviewCardsSettings"></SectionCards>
        <SectionCards v-bind="guitarCardsSettings"></SectionCards>
        <SectionCards v-bind="ukuleleCardsSettings"></SectionCards>
        <SectionCards v-bind="capoCardsSettings"></SectionCards>
        <SectionTestimonials v-bind="testimonialSettings"></SectionTestimonials>
        <SectionJumbo
            :image="$config.public.uploads + 'images-general/screen-shot-2021-05-04-at-13.png'"
            imageAlt="Andy playing his signature acoustic guitar with using his signature capo"
            imageOpacity="opacity-30"
            heading="Signature Products"
            headingComponent="h2"
            headingColor="text-white"
            content="<p>Check out my range of signature products</p>"
            contentColor="text-white"
            buttonText="Shop"
            buttonHref="https://shop.andyguitar.co.uk/collections/signature-collection"
            buttonTarget="_blank"
            :textCentered="false"
            imageLoading="lazy"
            fetchPriority="low"
        ></SectionJumbo>
    </Sections>
</template>

<script setup>
const {$config} = useNuxtApp();
useSeo().buildHead({
    title: 'Signature Products | ' + $config.public.siteName,
    description: 'Check out my range of signature products, carefully selected for your enjoyment.',
    index: true,
});
</script>

<script>

export default {
    computed: {
        overviewCardsSettings () {
            return {
                heading: 'Ready To Start Rocking?',
                headingComponent: 'h2',
                content: '<p class="font-weight-regular">My guitar and ukulele are the perfect instruments for beginners. Great quality at an even greater price!</p>',
                color: 'bg-zinc-50',
                cards: [
                    {
                        image: this.$config.public.uploads + 'images-product/andy-guitar-agf200-1-1.jpg',
                        imageAlt: 'Andy holding his signature acoustic guitar',
                        heading: 'Andys Signature Acoustic Guitar',
                        excerpt: '<p>Brunswick AGF200</p>',
                        colour: 'grey lighten-5',
                        href: 'https://shop.andyguitar.co.uk/products/andys-signature-acoustic-guitar-brunswick-agf200',
                        target: '_blank',
                    },
                    {
                        image: this.$config.public.uploads + 'images-product/agf200-capo-andyguitar-1.jpg',
                        imageAlt: 'Andy\'s signature capo',
                        heading: 'Andy Guitar Signature Capo',
                        excerpt: '<p>1000s more songs become playable for beginners with a capo!</p>',
                        href: 'https://shop.andyguitar.co.uk/products/andy-guitar-signature-capo',
                        target: '_blank',
                    },
                    {
                        image: this.$config.public.uploads + 'images-product/brunswick-ukeulele-bundle-2021-2-1.jpg',
                        imageAlt: 'Andy\'s signature Ukulele, Tuner & Bag Bundle',
                        heading: 'Andy\'s Signature Ukulele, Tuner & Bag BUNDLE!',
                        excerpt: '<p>conceived to look similar to my signature acoustic guitar and made to a top-notch spec</p>',
                        href: 'https://shop.andyguitar.co.uk/products/andys-signature-ukulele-tuner-bag-bundle',
                        target: '_blank',
                    },
                ],
            };
        },
        guitarCardsSettings () {
            return {
                heading: 'Andy\'s Signature Acoustic Guitar',
                headingComponent: 'h2',
                content: '<p>Brunswick AGF200, Andy\'s signature entry level acoustic guitar</p>',
                buttonText: 'Shop Guitar',
                buttonHref: 'https://shop.andyguitar.co.uk/products/andys-signature-acoustic-guitar-brunswick-agf200',
                buttonTarget: '_blank',
                cards: [
                    {
                        image: this.$config.public.uploads + 'images-general/sigprodcardguitar1-card.jpg',
                        imageAlt: 'Andy\'s signature guitar',
                        heading: 'Andy\'s Seal of Approval',
                        excerpt: '<p>This guitar has been designed to be the absolute best quality acoustic guitar you can buy in its price range!</p>',
                        color: 'bg-zinc-50',
                    },
                    {
                        image: this.$config.public.uploads + 'images-general/sigprodcardguitar3-2-2.jpeg',
                        imageAlt: 'Andy\'s signature guitar',
                        heading: 'Simply Beautiful',
                        excerpt: '<p>Laminated mahogany satin finish, cream binding, Composite wood fingerboard and bridge, High spec frets and machine heads and Aquila strings</p>',
                        color: 'bg-zinc-50',
                    },
                    {
                        image: this.$config.public.uploads + 'images-general/sigprodcardguitar2-card.jpg',
                        imageAlt: 'Andy\'s signature guitar',
                        heading: 'Quality Assured',
                        excerpt: '<p>Professionally set up by Brunswick UK for a great feel and comfortable action</p>',
                        color: 'bg-zinc-50',
                    },
                ],
            };
        },
        ukuleleCardsSettings () {
            return {
                heading: 'Andy\'s Guitar Concert Ukulele ',
                headingComponent: 'h2',
                content: '<p class="font-weight-regular">Brunswick AGCU200, Andy\'s signature ukulele</p>',
                buttonText: 'Shop Ukulele',
                buttonHref: 'https://shop.andyguitar.co.uk/products/andys-signature-ukulele-tuner-bag-bundle',
                buttonTarget: '_blank',
                color: 'bg-zinc-50',
                cards: [
                    {
                        image: this.$config.public.uploads + 'images-general/uke-agcu200-004.jpg',
                        imageAlt: 'Andy\'s signature ukulele',
                        heading: 'Quality Assured',
                        excerpt: '<p>Designed to the same high standard as my acoustic guitar. Every ukulele is professional inspected by Brunswick UK to ensure the highest quality.</p>',
                        color: 'bg-zinc-50',
                    },
                    {
                        image: this.$config.public.uploads + 'images-product/brunswick-ukeulele-bundle-2021-2-1.jpg',
                        imageAlt: 'Andy\'s signature ukulele, tuner and bag bundle',
                        heading: 'Bundle bonuses!',
                        excerpt: '<p>Bundle includes</p><ul><li>Brunswick AGCU200 Ukulele</li><li>Quality branded gig bag</li><li>TGI52U Ukulele tuner</li></ul>',
                        color: 'bg-zinc-50',
                    },
                    {
                        image: this.$config.public.uploads + 'images-general/uke-agcu200-002.jpg',
                        imageAlt: 'Andy\'s signature ukulele',
                        heading: 'Inherited Beauty',
                        excerpt: '<p>Same beautiful design as my signature acoustic guitar</p>',
                        color: 'bg-zinc-50',
                    },
                ],
            };
        },
        capoCardsSettings () {
            return {
                heading: 'Andy Guitar Signature Capo',
                headingComponent: 'h2',
                content: '<p class="font-weight-regular">Capos enable beginners to play 1000s more songs than they would be able to otherwise</p>',
                buttonText: 'Shop Capo',
                buttonHref: 'https://shop.andyguitar.co.uk/products/andy-guitar-signature-capo',
                buttonTarget: '_blank',
                cards: [
                    {
                        image: this.$config.public.uploads + 'images-general/agf200-capo-andyguitar-4.jpg',
                        imageAlt: 'Andy\'s signature capo on his signature guitar',
                        heading: 'No Fuss',
                        excerpt: '<p>Quick and EASY to put on and take off</p>',
                        color: 'bg-zinc-50',
                    },
                    {
                        image: this.$config.public.uploads + 'images-general/agf200-capo-andyguitar-5.jpg',
                        imageAlt: 'Andy easily fitting his signature capo to his signature ukulele',
                        heading: 'Multipurpose',
                        excerpt: '<p>Works great with both my signature guitar, ukulele and all other guitars and ukuleles.</p>',
                        color: 'bg-zinc-50',
                    },
                    {
                        image: this.$config.public.uploads + 'images-general/agf200-capo-andyguitar-3.jpg',
                        imageAlt: 'Andy\'s signature capo',
                        heading: 'Play Like a Pro',
                        excerpt: '<p>Many famous songs require a capo to be played correctly, such as Wonderwall and Hotel California, among countless others.</p>',
                        color: 'bg-zinc-50',
                    },
                ],
            };
        },
        testimonialSettings () {
            return {
                heading: 'Testimonials',
                headingComponent: 'h2',
                color: 'bg-zinc-50',
                testimonials: [
                    {
                        testimonialImage: this.$config.public.uploads + 'images-general/testimonials-sarah-patchett.jpg',
                        imageIsAvatar: true,
                        testimonialName: 'Sarah Patchett',
                        testimonialContent: 'I really love the guitar, great sound and much easier to play those bar chords for my small hands now! I\'m excited to learn much more with your tuition.',
                    },
                    {
                        testimonialImage: this.$config.public.uploads + 'images-general/uke-agcu200-001.jpg',
                        imageIsAvatar: true,
                        testimonialName: ' Phoebe',
                        testimonialContent: 'This Ukulele is a great starter instrument for me and it is so great to play!',
                    },
                    {
                        testimonialImage: this.$config.public.uploads + 'images-product/uke-agcu200-002-1.jpg',
                        imageIsAvatar: true,
                        testimonialName: 'Ian Wareing',
                        testimonialContent: 'I was lucky enough to get one of your Brunswick ukuleles for Xmas. I\'m having great fun with it and your song tutorials!',
                    },
                ],
            };
        },
    },
};
</script>
